import React from "react";
import { useCloud } from "./CloudProvider.js";

export const CloudTitle = () => {
  const { directory } = useCloud();

  return <h2>Files in {directory}</h2>;
};
